import { createFileRoute } from '@tanstack/react-router'

import { presetRange } from '@/features/reports-analytics/date-range'
import { performanceQueryOptions } from '@/features/reports-analytics/queries'
import { ReportsPage } from '@/features/reports-analytics/components/ReportsPage'

export const Route = createFileRoute('/_authed/reports')({
  loader: ({ context }) => {
    // Warm the default view (weekly / last 7 days) so the chart is ready on load.
    const today = new Date()
    const range = presetRange('last7', today)!
    return context.queryClient
      .ensureQueryData(performanceQueryOptions('weekly', range))
      .catch(() => undefined)
  },
  component: ReportsPage,
})
